/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu_badge[_ngcontent-%COMP%]{width:20px;height:20px;margin-right:5px;display:inline-flex;align-items:center;justify-content:center;border-radius:2px}"];
export { styles as styles };
